import { CircularProgress } from "@material-ui/core";
import React from "react";

const AppLoader = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        background: "#0d10314c",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          alignSelf: "center",
          margin: "auto",
          width: "50px",
          justifyContent: "space-around",
        }}
      >
        <CircularProgress style={{ margin: "auto", color: "#000000" }} />
      </div>
    </div>
  );
};

export default AppLoader;
